import React, { useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { AppDispatch } from 'components/store/state/store'
import Select, { IOption } from 'components/ui/abstract/Select'
import { useTranslation } from 'react-i18next'
import { SelectChangeEvent } from '@mui/material/Select/SelectInput'
import { IApplicationState } from 'components/store/types'
import { getCurrentPersonType, getCurrentTreatment } from 'components/core/state/selectors'
import { updateCurrentPersonType } from 'components/core/state/actions'
import constants from 'utils/constants'
import { ISetSearchParams, ITreatment } from 'components/core/types'
import { TFunction } from 'i18next'

const formatPersonTypesOptions = (currentTreatment: ITreatment, t: TFunction): IOption[] => Object
  .entries(constants.personTypes)
  .map(([key, value]) => {
    const disabled = ((value === constants.personTypes['3']) && currentTreatment?.except_kids)
    return {
      value: parseInt(key, 10),
      label: t(`personTypes.${value}`) + (disabled ? ` (${t('except-treatment')})` : ''),
      disabled,
    }
  })

const mapState = (state: IApplicationState) => ({
  currentPersonType: getCurrentPersonType(state),
  currentTreatment: getCurrentTreatment(state),
})
const mapDispatch = (dispatch: AppDispatch) => ({
  updatePersonType: (personTypeId: number, setSearchParams: ISetSearchParams) => {
    dispatch(updateCurrentPersonType(personTypeId, setSearchParams))
  },
})
const connector = connect(mapState, mapDispatch)

interface SelectPersonTypeProps extends ConnectedProps<typeof connector> {
  big?: boolean,
}

const SelectPersonType = ({
  big,
  currentPersonType,
  currentTreatment,
  updatePersonType,
}: SelectPersonTypeProps) => {
  const { t } = useTranslation()
  const [, setSearchParams] = useSearchParams()
  const [options, setOptions] = useState(formatPersonTypesOptions(currentTreatment, t))
  const [selected, setSelected] = useState(currentPersonType)
  const handleChange = (event: SelectChangeEvent) => {
    updateValue(parseInt(event.target.value, 10))
  }

  useEffect(() => {
    setOptions(formatPersonTypesOptions(currentTreatment, t))
    updateValue(currentPersonType)
  }, [currentPersonType, currentTreatment])

  const updateValue = (newValue: number) => {
    if (options.length) {
      const newOption = options.filter((option) => option.value === newValue)
      if (newOption[0]?.disabled) {
        updateValue(1)
      }
    }
    if (newValue === selected) {
      return
    }
    setSelected(newValue)
    updatePersonType(newValue, setSearchParams)
  }

  if (!selected || !options.length) {
    return null
  }
  return (
    <Select
      big={big}
      options={options}
      defaultValue={selected}
      onChange={handleChange}
    />
  )
}
SelectPersonType.defaultProps = {
  big: false,
}
export default connector(SelectPersonType)
